export default "__VITE_ASSET__bFuZ7rrj__"